import getData from "@/__main__/get-data.mjs";
import { appURLs } from "@/app/constants.mjs";
import * as GraphQLTemplatesDatalake from "@/game-lol/graphql-templates-datalake.mjs";
import ChampionsStats from "@/game-lol/models/lol-champions-arena.mjs";
import { queryGQL } from "@/util/gql-formatters.mjs";

function queryArenaStats() {
  return queryGQL(
    appURLs.DATALAKE,
    GraphQLTemplatesDatalake.ArenaChampionsStats,
  );
}

export default function (path: string[], options?: object) {
  return getData(
    queryArenaStats(),
    ChampionsStats,
    path || ["lol", "championsArenaStats"],
    {
      ...(options || {}),
      // shouldFetchIfPathExists: false,
      // expiryTime: Date.now() + 2 * 60 * 60 * 1000, // 2 hours
    },
  );
}
